module.exports = "<div class=\"mui-group-item no-access mui-group-item-switch\" v-if=isGroupItem> <div class=mui-group-item-hd> <label class=mui-label :style=\"{width: labelWidth || defaultLabelWidth + 'em'}\" v-if=title>{{title}}</label> <inline-desc v-if=inlineDesc>{{inlineDesc}}</inline-desc> </div> <div class=\"mui-group-item-bd mui-group-item-primary\"> <slot></slot> </div> <div class=mui-group-item-ft> <input class=mui-switch type=checkbox :disabled=disabled v-model=value /> </div> </div> <input v-else class=mui-switch type=checkbox :disabled=disabled v-model=value />";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/index.vue
 ** module id = 176
 ** module chunks = 0
 **/